import { Listbox, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import { AiFillCaretDown } from 'react-icons/all';
import useAdmin from '../../hooks/useAdmin';
import styles from './style.module.scss';

const SelectList = ({ list, onChange, selected, placeholder, showAdminTag }) => {
  const [isAdmin] = useAdmin();
  const getDisplayLabel = () => {
    if (!selected) return;
    const selectedItem = list?.find((item) => selected == item.apobSupplierID);
    if (!selectedItem) return;
    return selectedItem.label;
  };
  const displaylabel = getDisplayLabel();
  return (
    <>
      <Listbox value={selected}>
        <Listbox.Button className={styles.listBox2}>
          <span className={styles.listBox2Span}>
            {(displaylabel && displaylabel.toUpperCase()) || placeholder}
            {showAdminTag && isAdmin && ' (Admin)'}
          </span>
          <span className={styles.span_list_style}>
            <AiFillCaretDown className={styles.dropdownIcon} aria-hidden="true" />
          </span>
        </Listbox.Button>

        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className={styles.span_list_style2}>
            {list?.map((item) => (
              <Listbox.Option
                key={item.apobSupplierID}
                value={item.apobSupplierID}
                className={
                  item.apobSupplierID === selected
                    ? styles.span_list_style6
                    : styles.span_list_style3
                }
                onClick={() => {
                  onChange(item);
                }}
              >
                <span className={styles.span_list_style4}>
                  {item.label && item.label.toUpperCase()}
                </span>
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </Listbox>
    </>
  );
};

export default SelectList;
